import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header/header";
import Nav from "./components/Navigation/nav";
import About from "./components/About/about";
import Experiences from "./components/Experiences/experience";
import Services from "./components/Services/services";
import Portfolio from "./components/Portfolio/portfolio";
import Testimonial from "./components/Testimonial/testimonial";
import Contact from "./components/Contacts/contact";
import Footer from "./components/Footer/footer";
import Login from "./components/AdminPanel/Login";
import SignUp from "./components/AdminPanel/SignUp";
import AdminSidebar from "./components/AdminPanel/AdminSidebar";
import GitHubGraph from "./components/GitHubGraph/GitHubGraph";
import CLIModal from "./components/CLI/CLIModal";
import SEOHelmet from "./components/SEO/SEOHelmet";
import Cookies from "js-cookie";

export const baseURL = process.env.REACT_APP_BASE_URL;

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    !!Cookies.get("token"),
  );

  return (
    <HelmetProvider>
      <SEOHelmet />
      <Router>
        <Routes>
          {/* Public Routes */}
          <Route
            path="/"
            element={
              <>
                <Header />
                <Nav />
                <About />
                <Experiences />
                <GitHubGraph username="Aubin9" />
                <Services />
                <Portfolio />
                <Testimonial />
                <Contact />
                <Footer />
                <CLIModal />
              </>
            }
          />

          {/* Auth Routes */}
          <Route
            path="/login"
            element={<Login setIsAuthenticated={setIsAuthenticated} />}
          />
          <Route path="/signup" element={<SignUp />} />

          {/* Protected Admin Route */}
          <Route
            path="/admin/*"
            element={
              isAuthenticated ? (
                <AdminSidebar setIsAuthenticated={setIsAuthenticated} />
              ) : (
                <Navigate to="/login" />
              )
            }
          />
        </Routes>
      </Router>
    </HelmetProvider>
  );
};

export default App;
